import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

// MODELOS
import {
  CompanyModelResponse, CompanyListResponse, CompanyModel, SapConnectionModel, SapConnResponse

} from './../../../models/index'

// RUTAS
// COMPONENTES
// SERVICIOS
import { AlertService, ConfigParamsService } from './../../../services/index'

@Component({
  selector: 'app-manager',
  templateUrl: './manager.component.html',
  styleUrls: ['./manager.component.css']
})
export class ManagerComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  public createManagerForm: FormGroup;
  public updateManagerForm: FormGroup;

  managerList: Array<any>; // obj almacena la lista de gestores
  managerInEdition: any; // obj almacena el gestor seleccionado
  sapConnList: Array<SapConnectionModel>; // obj que almacena conexiones sap
  emailManagerList: Array<any>; // obj almacena la lista de correos de los gestores
  userList: Array<any>; // obj almacena la lista de usuarios para asignar a gestores
  constructor(private fb: FormBuilder,
    private configParamsService: ConfigParamsService,
    private alertService: AlertService
  ) { }

  errorMessage: string; // variable para el mensaje en caso de error

  ngOnInit() {
    this.ngOnLoad();
  }

  ngOnLoad() {
    this.createManagerForm = this.fb.group({
      userSelected: ['', Validators.required],
      managerName: ['', Validators.required],
      managerStatus: ['', Validators.required],
      managerEmail: [''],
      managerPassword: ['', Validators.required],
      managerHost: ['', Validators.required],
      managerPort: ['', Validators.required],
      managerSSL: [false],
    });

    this.updateManagerForm = this.fb.group({
      managerSelected: ['', Validators.required],
      managerName: ['', Validators.required],
      managerStatus: ['', Validators.required],
      managerEmail: [{ value: '', disabled: true }, Validators.required],
      managerPassword: [''],
      managerHost: ['', Validators.required],
      managerPort: ['', Validators.required],
      managerSSL: [false],
    });

    this.getManagerList();
    //this.getEmailManagerList(); 
    this.getUserList();
  }

  get createFormManager() {
    return this.createManagerForm.controls;
  }
  get updateFormManager() {
    return this.updateManagerForm.controls;
  }

  getManagerList() {
    this.blockUI.start('Buscando gestores');
    console.log('Buscando gestores');
    this.configParamsService.getManagerList()
      .subscribe((data: any) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.managerList = data.ManagerList;
          this.blockUI.stop();
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  // getEmailManagerList() {
  //   this.blockUI.start('Buscando correos de gestores');
  //   console.log('Buscando correos gestores');
  //   this.configParamsService.getEmailManagerList()
  //     .subscribe((data: any) => {
  //       console.log(data);
  //       console.log(data.result);
  //       if (data.result) {
  //         this.emailManagerList = data.ManagerEmailConfigList;
  //         this.blockUI.stop();          
  //       } else {
  //         this.blockUI.stop(); // Stop blocking
  //         this.errorMessage = data.errorInfo.Message;
  //         this.alertService.warningAlert(`${data.errorInfo.Message}`);
  //       }
  //     }, (error: any) => {
  //       console.log(error);
  //       this.blockUI.stop(); // Stop blocking
  //       this.alertService.errorAlert(`${error}`);
  //     });
  // }

  getUserList() {
    this.blockUI.start('Buscando usuarios');
    console.log('Buscando usuarios');
    this.configParamsService.getUserList()
      .subscribe((data: any) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.userList = data.AspNetUsersFromMisSecList;
          this.blockUI.stop();
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  createManager() {
    this.blockUI.start('Creando gestor, un momento por favor.');
    console.log('Creando gestor');
    let userId = this.createManagerForm.controls['userSelected'].value;
    let emailUser = this.userList.filter(x => x.AspNetUserId == userId).map(y => y.AspNetUserEmail);
    this.createManagerForm.controls['managerEmail'].setValue(emailUser[0]);
    this.configParamsService.createManager(this.createManagerForm)
      .subscribe((data: any) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.alertService.successAlert("Gestor creado correctamente");
          this.createManagerForm.reset();
          this.getManagerList();
          this.getUserList();
          this.blockUI.stop();
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  updateManager() {
    this.blockUI.start('Acutalizando el gestor, un momento por favor.');
    console.log('Acutalizando el gestor');
    this.configParamsService.updateManager(this.managerInEdition, this.updateManagerForm)
      .subscribe((data: any) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.alertService.successAlert("Gestor actualizado correctamente");
          this.updateManagerForm.reset();
          this.getManagerList();
          this.getUserList();
          this.blockUI.stop();
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  managerSelected($event) {
    console.log("CompanySelected");
    this.managerInEdition = undefined;
    this.managerInEdition = this.managerList.find(manager => manager.Id == $event.target.value);
    if (this.managerInEdition) {
      this.PatchAlertData(this.managerInEdition);
    } else {
      this.updateManagerForm.reset();
    }
  }

  PatchAlertData(managerInEdition: any) {
    console.log("CompanyPatch");
    this.updateManagerForm.reset({
      managerSelected: managerInEdition.Id,
      managerName: managerInEdition.ManagerName,
      managerStatus: managerInEdition.Active,
      managerEmail: managerInEdition.Email,
      //managerPassword: managerInEdition.Password,
      managerHost: managerInEdition.Host,
      managerPort: managerInEdition.Port,
      managerSSL: managerInEdition.SSL

    })
  }
}
